import { render, staticRenderFns } from "./research-ebay.vue?vue&type=template&id=4bb71515&scoped=true"
import script from "./research-ebay.vue?vue&type=script&setup=true&lang=js"
export * from "./research-ebay.vue?vue&type=script&setup=true&lang=js"
import style0 from "./research-ebay.vue?vue&type=style&index=0&id=4bb71515&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb71515",
  null
  
)

export default component.exports